const convertToPieData = (data) => {
  return data.map((item) => ({
    name: item.reason,
    prePrimaryCount: item.prePrimaryCount,
    primaryCount: item.primaryCount,
    secondaryCount: item.secondaryCount,
    tvetCount: item.tvetCount,
    male: item.maleCount,
    female: item.femaleCount,
    total: item.teachingAndAdministrativeStaffTotal,
    teachingStaffTotal: item.teachingStaffTotal,
  }));
};

const calculateTotals = (data, scope) => {
  const totals = {
    prePrimaryCount: 0,
    primaryCount: 0,
    secondaryCount: 0,
    tvetCount: 0,
    total: 0,
  };

  data.forEach((item) => {
    totals.prePrimaryCount += item.prePrimaryCount || 0;
    totals.primaryCount += item.primaryCount || 0;
    totals.secondaryCount += item.secondaryCount || 0;
    totals.tvetCount += item.tvetCount || 0;
    totals.total += item.total || 0;
  });

  return totals;
};

export default function TurnoverReasonsChart({ data, scope }) {
  const tableData = convertToPieData(data);
  const totals = calculateTotals(tableData, scope);

  return (
    <table style={{ borderCollapse: "collapse", width: "100%" }}>
      <thead>
        <tr style={{ backgroundColor: "#f9f9f9" }}>
          <th
            style={{
              border: "1px solid #ddd",
              padding: "10px 10px 10px 20px",
              textAlign: "left",
            }}
          >
            Reason
          </th>
          {scope === "REB" ? (
            <>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                Pre-Primary
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                Primary
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                Secondary
              </th>
            </>
          ) : (
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              TVET
            </th>
          )}
          <th
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              textAlign: "center",
            }}
          >
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {tableData.map((item, index) => (
          <tr
            key={index}
            style={{
              backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
            }}
          >
            <td
              style={{
                border: "1px solid #ddd",
                padding: "10px 10px 10px 20px",
              }}
            >
              {item.name}
            </td>
            {scope === "REB" ? (
              <>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {item.prePrimaryCount?.toLocaleString()}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {item.primaryCount?.toLocaleString()}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {item.secondaryCount?.toLocaleString()}
                </td>
              </>
            ) : (
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.tvetCount?.toLocaleString()}
              </td>
            )}
            <td
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              {item.total?.toLocaleString()}
            </td>
          </tr>
        ))}
        <tr style={{ backgroundColor: "hsl(var(--chart-1))", fontWeight: "bold", color: "white" }}>
          <td
            style={{
              border: "1px solid #ddd",
              padding: "10px 10px 10px 20px",
            }}
          >
            Total
          </td>
          {scope === "REB" ? (
            <>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {totals.prePrimaryCount?.toLocaleString()}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {totals.primaryCount?.toLocaleString()}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {totals.secondaryCount?.toLocaleString()}
              </td>
            </>
          ) : (
            <td
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              {totals.tvetCount?.toLocaleString()}
            </td>
          )}
          <td
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              textAlign: "center",
            }}
          >
            {totals.total?.toLocaleString()}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
